<template>
    <v-flex class="custom-tooltip__info" v-if="waiverVotes">
        <v-flex class="custom-tooltip__info__details">
        <v-flex class="info-list" v-for="(panelVoter, i) in waiverVotes" :key="i">
            <img :src="panelVoter.panelVoterProfileImageUrl" :onerror="imageErrorFallback(panelVoter)" :data-qe-id="`panel_voter_image_${i}`"/>
            <span>{{panelVoter.panelVoterName}}</span>
        </v-flex>
        </v-flex>
    </v-flex>
</template>

<script>

    export default {
        name: "PanelMemberToolTip",
        data: () => { return {}; },
        props: {
            waiverVotes: {
                type: Array,
                required: true,
            },
        },
        methods: {
            imageErrorFallback(element) {
                return `this.src='${element.panelVoterFallbackProfileImageUrl || ''}';this.onerror=null;`;
            },
        },
    };
</script>
